import { useSession } from "@outschool/ui-auth";
import React from "react";

const StickyHeaderContext = React.createContext<{
  headerHeight: number;
  enabled: boolean;
}>({ headerHeight: 0, enabled: false });

const StickyHeaderProvider = ({
  headerRef,
  children
}: {
  headerRef: React.RefObject<HTMLDivElement> | null;
  children: React.ReactNode;
}) => {
  const { isLoggedIn } = useSession();
  const [headerHeight, setHeaderHeight] = React.useState(0);
  const enabled = !isLoggedIn;

  React.useLayoutEffect(() => {
    if (enabled && headerRef?.current) {
      const height = headerRef.current.getBoundingClientRect().height;
      setHeaderHeight(height);
    }
  }, [enabled, headerRef]);

  return (
    <StickyHeaderContext.Provider
      value={{ headerHeight, enabled: enabled && !!headerRef?.current }}
    >
      {children}
    </StickyHeaderContext.Provider>
  );
};

const useStickyHeader = () => {
  const context = React.useContext(StickyHeaderContext);
  if (!context) {
    throw new Error(
      "useStickyHeader must be used within a StickyHeaderProvider"
    );
  }
  return context;
};

export { StickyHeaderProvider, useStickyHeader };
